module.exports = __webpack_public_path__ + "static/icon-welfare.7297a962.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-welfare.png
// module id = 296
// module chunks = 2